module.exports = __webpack_public_path__ + "static/media/adhesive-screw-set.f1908d2e.png";